import { useAppContext } from "../../context/AppContext";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// prime react
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
// components
import Panel from "../../components/panel/panel";
import ExportTable from "../../components/button/ExportButton";
// utils and pages
import { formatDate } from "../../utils/formatDate";

export function TableCommission({
  dataTable,

  globalFilterValue,
  onGlobalFilterChange,
}) {
  //for block and lot
  const { nomenclatures } = useAppContext();
  const nomenclature = nomenclatures ? JSON.parse(nomenclatures) : [];
  //for export table in excel
  const [tableToExport, setTableToExport] = useState(null);

  const navigate = useNavigate();
  // Função para lidar com o clique no botão "Lançar"
  const handleLaunchClick = (commissionId) => {
    console.log("Id da venda :", commissionId);
    navigate("/financial/launchCommissionSale", {
      //passando as coisas pra outra pagina
      state: {
        commissionId,
      },
    });
  };

  const columns = [
    { field: "sale_id", header: "Contrato" },
    { field: "enterprise", header: "Empreendimento" },
    { field: "real_estate", header: "Imobiliária" },
    { field: "broker", header: "Vendedor" },
    { field: "client", header: "Comprador" },
    {
      field: "block",
      header: `${nomenclature[0]?.value || "Quadra"}`,
    },
    {
      field: "land",
      header: `${nomenclature[1]?.value || "Lote"}`,
    },
    {
      field: "created_at",
      header: "Data da Venda",
      body: (object) => formatDate(object.created_at), // Aplicando a função de formatação
    },
    {
      field: "action",
      header: "Ação",
      body: (object) => {
        // Define os rótulos e classes do botão com base no status
        let buttonLabel;
        let buttonClass;
        let handleClick;

        switch (object.status) {
          case 0: // Status Pendente (Lançar)
            buttonLabel = "Lançar";
            buttonClass = "btn btn-primary";
            handleClick = () => handleLaunchClick(object.id);
            break;

          case 1: // Status Aprovado (Visualizar)
            buttonLabel = "Visualizar";
            buttonClass = "btn btn-secondary";
            handleClick = () =>
              navigate("/financial/viewCommission", {
                state: { commissionId: object.id },
              });
            break;

          case 2: // Status Recusado (Botão vermelho, ação de relançar)
            buttonLabel = "Recusada";
            buttonClass = "btn btn-danger"; // Botão vermelho
            handleClick = () => handleLaunchClick(object.id); // Permite relançar
            break;

          default:
            buttonLabel = "Indefinido";
            buttonClass = "btn btn-outline-dark";
            handleClick = () =>
              console.warn("Status desconhecido:", object.status);
            break;
        }

        return (
          <button className={buttonClass} onClick={handleClick}>
            {buttonLabel}
          </button>
        );
      },
    },
  ];
  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  useEffect(() => {
    if (dataTable) {
      const dataWithoutIds = dataTable.map((t) => ({
        Contrato: t.id,
        Empreendimento: t.enterprise,
        Imobiliaria: t.real_estate,
        Corretor: t.broker,
        Comprador: t.client,
        Quadra: t.block,
        Lote: t.land,
        DataVenda: formatDate(t.created_at), // Aplicando a formatação aqui
      }));
      setTableToExport(dataWithoutIds);
    }
  }, [dataTable]);

  return (
    <Panel mainCss="mt-4">
      <div className="px-2 pb-3">
        <ExportTable
          tableData={tableToExport}
          exportColumns={exportColumns}
          tabelaKey="Comissões"
          globalFilterValue={globalFilterValue}
          onGlobalFilterChange={onGlobalFilterChange}
          orientation="landscape"
        />
        <DataTable
          value={dataTable}
          stripedRows
          showGridlines
          sortMode="multiple"
          selectionMode="multiple"
          globalFilter={globalFilterValue}
          emptyMessage="Nenhuma Informação foi encontrada."
          tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
        >
          {/* <Column
            field="id"
            headerStyle={{ width: "3rem" }}
            selectionMode="multiple"
          /> */}
          {columns.map((col, i) => (
            <Column
              sortable
              body={col.body}
              key={i}
              style={{ minWidth: 150 }}
              field={col.field}
              header={col.header}
            />
          ))}
        </DataTable>
      </div>
    </Panel>
  );
}
